"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.virtualizedSelectOptionRenderer = void 0;
var React = _interopRequireWildcard(require("react"));
var _underscore = _interopRequireDefault(require("underscore"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * This file was copied from the default option renderer in react-virtualized-select,
 * but it was modified to check for equality by option values, not by option references.
 * This fixes issues with styling focused and selected options.
 * @param props
 * @returns {React.DetailedReactHTMLElement<React.HTMLAttributes<T>, HTMLElement>}
 */
var virtualizedSelectOptionRenderer = exports.virtualizedSelectOptionRenderer = function virtualizedSelectOptionRenderer(_ref) {
  var focusedOption = _ref.focusedOption,
    focusOption = _ref.focusOption,
    key = _ref.key,
    labelKey = _ref.labelKey,
    option = _ref.option,
    selectValue = _ref.selectValue,
    style = _ref.style,
    valueArray = _ref.valueArray;
  var className = ['VirtualizedSelectOption'];
  if (option && focusedOption && _underscore["default"].isEqual(focusedOption, option)) {
    className.push('VirtualizedSelectFocusedOption');
  }
  if (option.disabled) {
    className.push('VirtualizedSelectDisabledOption');
  }
  if (valueArray && option && valueArray.findIndex(function (valueArrayOption) {
    return _underscore["default"].isEqual(valueArrayOption, option);
  }) >= 0) {
    className.push('VirtualizedSelectSelectedOption');
  }
  if (option.className) {
    className.push(option.className);
  }
  var events = option.disabled ? {} : {
    onClick: function onClick() {
      return selectValue(option);
    },
    onMouseEnter: function onMouseEnter() {
      return focusOption(option);
    }
  };
  return /*#__PURE__*/React.createElement('div', _underscore["default"].extend({
    className: className.join(' '),
    key: key,
    style: style,
    title: option.title
  }, events), option[labelKey]);
};